export const cacheKeys = {
  getPrograms: 'getPrograms',
  getProgram: 'getProgram',
  resolveProgramLink: 'resolveProgramLink',
  getEnrollments: 'getEnrollments',
  getEnrollment: 'getEnrollment',
  createEnrollment: 'createEnrollment',
  createStepEntry: 'createStepEntry',
};
